// import { MatSnackBarConfig } from '@angular/material/snack-bar';

export const toastrConfig: any = {
  duration: 4000,
  horizontalPosition: 'end',
  verticalPosition: 'top',
};

export const toastrBottomConfig: any = {
  duration: 4000,
  horizontalPosition: 'start',
  verticalPosition: 'bottom',
};
